import React from "react";
import Modal, { ModalButton } from "common/modal";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface SubscribeAgainModalProps {
  loading: boolean;
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ModalText = styled.div`
  margin: 8px 0px 12px;
  font-size: 18px;
  color: #282828;
`;

const SubscribeAgainModal = ({
  loading,
  visible,
  onConfirm,
  onCancel,
}: SubscribeAgainModalProps) => {
  const { t } = useTranslation("my_credits");

  return (
    <Modal title={t("RE-SUBSCRIBE")} visible={visible} onCancel={onCancel}>
      <ModalText>
        {t("Welcome back and it will be great to have you on board again.")}
      </ModalText>

      <br />

      <ModalButton loading={loading} onClick={() => onConfirm()}>
        {t("RE-SUBSCRIBE")}
      </ModalButton>
      <ModalButton onClick={() => onCancel()}>{t("CLOSE WINDOW")}</ModalButton>
    </Modal>
  );
};

export default SubscribeAgainModal;
